import loadable from "@loadable/component";
import { RPFormattedMessage } from "@src/i18n";

const AdminPage = loadable(() => import("@src/admin"));

const LazyAdminPage = () => (
  <AdminPage
    fallback={
      <div className="d-flex flex-row justify-content-center mt-5">
        <p>
          <RPFormattedMessage
            id="adminPageCheckingPermission"
            defaultMessage="Tarkastamme kulkulupasi, hetki vain!"
          />
        </p>
      </div>
    }
  />
);

export default LazyAdminPage;
